import React from 'react';
import { SVGComp, PathComp } from '../../components/Svgs';
import { useTheme } from '@hmsexp/component-library';

const GenricIconPopover = ({ width = '14', height = '16', viewBox = '0 0 14 16', stroke = 'white' }) => {
  const theme = useTheme();
  return (
    <SVGComp width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <PathComp
        d="M8.15333 14.0007C8.03613 14.2027 7.8679 14.3704 7.66548 14.487C7.46307 14.6036 7.23359 14.665 7 14.665C6.76641 14.665 6.53693 14.6036 6.33452 14.487C6.13211 14.3704 5.96387 14.2027 5.84667 14.0007M11 5.33398C11 4.27312 10.5786 3.2557 9.82843 2.50556C9.07828 1.75541 8.06087 1.33398 7 1.33398C5.93913 1.33398 4.92172 1.75541 4.17157 2.50556C3.42143 3.2557 3 4.27312 3 5.33398C3 10.0007 1 11.334 1 11.334H13C13 11.334 11 10.0007 11 5.33398Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVGComp>
  );
};

export default GenricIconPopover;
